import { useUserStore } from "../store/user-store"
import { fetchUserProfile } from "../community-api"
import { dedupFetch } from "./request-dedup"

const USER_SWR = { staleTime: 5 * 60_000 } // 5 minutes

export async function loadUser(userId: string, force = false): Promise<void> {
  const { data } = await dedupFetch(
    `user:${userId}`,
    () => fetchUserProfile(userId),
    {
      ...USER_SWR,
      force,
      onStaleRevalidate: (fresh) => {
        if (fresh) {
          const store = useUserStore.getState()
          store.upsertUser(fresh)
          if (userId !== fresh.id) store.upsertAlias(userId, fresh.id)
        }
      },
    },
  )

  if (data) {
    const store = useUserStore.getState()
    store.upsertUser(data)
    if (userId !== data.id) store.upsertAlias(userId, data.id)
  }
}
